import Head from "next/head";

const PageHead = ({ title, isHomePage = false}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content="La Institución Educativa Colegio Menfis, con 25 años de trayectoria en Chinchiná, ofrece una educación lúdico-pedagógica centrada en el desarrollo integral de niños y jóvenes. Nuestra propuesta educativa se distingue por el enfoque en el bilingüismo, adaptándose a las demandas del siglo XXI." />
        <meta name="keywords" content="colegio bilingüe Colombia, educación internacional Chinchiná, worldschooling Colombia, escuela bilingüe eje cafetero, colegio internacional Caldas, educación para expatriados Colombia, bilingual school coffee region, international education Colombia, Colegio Menfis, pedagogía lúdica, desarrollo integral niños, educación siglo XXI, colegios Chinchiná, familias internacionales Colombia, coffee region schools" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="author" content="Colegio Menfis" />
        <link rel="canonical" href="https://colegiomenfis.org/" />
        <link rel="icon" href="/favicon.ico" />

        {/*  <!-- Geo Tags for Local SEO --> */}
        <meta name="geo.region" content="CO-CAL" />
        <meta name="geo.placename" content="Chinchiná" />
        <meta name="geo.position" content="4.983333;-75.600000" />
        <meta name="ICBM" content="4.983333, -75.600000" />
  
        {/*   <!-- Open Graph Meta Tags --> */}
        <meta property="og:locale" content="es_CO" />
        <meta property="og:locale:alternate" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Colegio Menfis" />
        <meta property="og:title" content="Colegio Menfis | Educación con enfoque Bilingüe e Internacional en Chinchiná." />
        <meta property="og:description" content="Institución educativa con enfoque bilingüe con 25 años de experiencia. Educación internacional, worldschooling y desarrollo integral en el Eje Cafetero colombiano." />
        <meta property="og:image" content="https://colegiomenfis.org/images/banner/menfis_banner_2.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Colegio Menfis - Educación con Enfoque Bilingüe en Chinchiná" />
        <meta property="og:url" content="https://colegiomenfis.org/" />
  
        {/*   <!-- Twitter Card Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Colegio Menfis | Educación con Enfoque Bilingüe e Internacional" />
        <meta name="twitter:description" content="Institución educativa con enfoque bilingüe con 25 años de experiencia en Chinchiná, Colombia. Worldschooling y desarrollo integral." />
        <meta name="twitter:image" content="https://colegiomenfis.org/images/banner/menfis_banner_2.jpg" />

      </Head>
    </>
  );
};

export default PageHead;
